// Form fields that get persisted to URL params
export const URL_PARAM_FIELDS = [
  "sku",
  "short_description",
  "medium_description",
  "long_description",
  "product_category_id",
  "standardized_product_id",
  "product_grade_id",
  "product_brand_id",
  "new_brand_name",
  "country_of_origin",
  "wild_or_farmed",
  "fresh_or_frozen",
  "primary_source_species",
  "allergens",
  "default_price_uom",
] as const;

// Variant fields to persist in URL params
export const VARIANT_FIELDS = [
  "sell_uom",
  "sell_weight",
  "sell_weight_uom",
  "sell_weight_approximate",
  "sell_count",
  "sell_count_uom",
  "sell_approximate",
  "part_count",
  "part_count_approximate",
  "sell_size_uom",
  "sell_size_approximate",
  "sell_sizes",
  "sell_size_range_min",
  "sell_size_range_max",
  "sell_size_range_step",
  "extra_charge_per_uom",
  "currency_code",
] as const;

export interface UomClassification {
  measurable: string[];
  countable: string[];
}
